import { fetchLib, getJson, getStatus } from "utils";
import { SERVICE_URL } from "../constants";

/**
 * Api to send chat invite link
 * @param {*} Authorization
 * @param {*} payload
 * @returns {*} { status: number, data: { response: boolean }}
 */
export const sendChatInviteLinkService = async (Authorization, payload) => {
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization,
    },
    body: JSON.stringify(payload),
  };

  const response = await fetchLib(
    `${SERVICE_URL}api/notify/resend-sms`,
    options
  );
  const status = getStatus(response);
  const data = await getJson(response);

  return {
    status,
    data,
  };
};
